// semeia-disable-reexport
/**
 * This function transforms the data given as a parameter to always return
 * an array if it's not the case.
 */
export function arrayIfNeeded<T>(data: T | Array<T>): Array<T> {
  if (!data) return [];
  if (Array.isArray(data)) return data;
  return [data];
}
